// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"150":"98a51746","723":"14963d38"}[chunkId] + ".chunk.css";
};